module.exports = __webpack_public_path__ + "static/img/1.0e92270.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/1.png
// module id = IKsR
// module chunks = 0